export default __webpack_public_path__ + "static/media/cumple.b7fa61cd.png";